// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleArtistLine_root__yI33Q"};